<template>
  <IconButton
    @click.stop.prevent="disabled ? null : onClick()"
    :disabled="disabled"
    icon="icon-barcode"
    size="small"
    color="medium"
  ></IconButton>
</template>

<script setup lang="ts">
import { useBarcodeScanner } from '@/composables/use-barcode-scanner';
import IconButton from './forms/IconButton.vue';
import { useToast } from '@/composables/use-toast';
import { CapacitorBarcodeScannerTypeHint } from '@capacitor/barcode-scanner';

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    hint?: CapacitorBarcodeScannerTypeHint;
  }>(),
  { hint: CapacitorBarcodeScannerTypeHint.CODE_128 }
);

const emit = defineEmits<{
  (e: 'onScan', scanned: number): void;
}>();

const { errorToast } = useToast();
const { scan } = useBarcodeScanner(props.hint);

async function onClick() {
  const result = await scan();
  if (result.success) {
    emit('onScan', result.scanned);
  } else if (result.errorMsg) {
    errorToast(result.errorMsg);
  }
}
</script>

<style scoped></style>
